/* eslint-disable lodash/prefer-lodash-method */
import React, { Component } from 'react';
import _ from 'lodash';
import JsonapiClient from '@holidayextras/jsonapi-client';
import { authService } from '../../../utils/auth-service';


const withInvitationsData = WrapperComponent => class extends Component {
  constructor() {
    super();
    this.jsonAPIClient = new JsonapiClient(process.env.REACT_APP_API_BASE_URL, {
      header: {
        Authorization: `Bearer ${authService.getToken()}`,
      },
    });
  }


  getPendingInvitationsCountByEmail = userEmail => this.jsonAPIClient
    .find('campaignInvitation', {
      filter: {
        email: userEmail,
        status: 'SENT',
      },
    }).then(response => _.size(response))

  getPendingInvitationsByUserEmail = (userEmail, shouldFetchDeclinedInvitations) => this.jsonAPIClient
    .find('campaignInvitation', {
      filter: {
        email: userEmail,
        status: shouldFetchDeclinedInvitations ? 'SENT,DECLINED' : 'SENT',
      },
      include: ['campaign'],
    }).then(response => _.map(response, item => item.toJSONTree()));

  updateInvitationStatusById = (invitationId, status) => this.jsonAPIClient.get(
    'campaignInvitation',
    invitationId).then(resource => {
    resource.set('status', status);
    return resource.sync();
  })

  render() {
    return (
      <WrapperComponent
        {...this.props}
        getPendingInvitationsByUserEmail={this.getPendingInvitationsByUserEmail}
        updateInvitationStatusById={this.updateInvitationStatusById}
        getPendingInvitationsCountByEmail={this.getPendingInvitationsCountByEmail}
      />
    );
  }
};

export default withInvitationsData;



/** WEBPACK FOOTER **
 ** ./src/hocs/data/with-pending-invitations/index.js
 **/